<template>
  <section class="h_53">
    <m-img src="@/v2/mobile/assets/image/h_53_1.jpg"></m-img>
    <div class="video_container">
      <div
        class="video1 border_container_night video_size f-select-center"
        v-ia
      >
        <m-video
          src="@/v2/mobile/assets/video/v_53.mp4"
          poster="@/v2/mobile/assets/video/poster/v_53.webp"
          disablepictureinpicture
          muted
          x5-playsinline
          playsinline
          webkit-playsinline="true"
          autoplay
          ref="video"
        ></m-video>
      </div>
      <replay
        class="alive_replay"
        @click="() => replayVideo(this.$refs.video)"
      />
    </div>
    <m-img src="@/v2/mobile/assets/image/h_53_2.jpg"></m-img>
  </section>
</template>

<script>
import { videoPlayByVisibleAreaH5, replayVideo } from '@/utils'
import replay from '@/components/replay.vue'
export default {
  components: {
    replay,
  },
  data() {
    return {
      preload_: true,
    }
  },
  mounted() {
    this.$refs.video && videoPlayByVisibleAreaH5(this.$refs.video)
  },
  methods: {
    replayVideo,
  },
}
</script>
<style lang="less" scoped>
.h_53 {
  position: relative;
  .video_container {
    position: absolute;
    width: 90%;
    top: 23%;
    left: 50%;
    transform: translateX(-50%);
    .video1 {
      position: relative;
      display: flex;
      overflow: hidden;
      video {
        object-fit: cover;
        width: 100%;
        height: 100%;
      }
    }
    .alive_replay {
      margin-top: 22px;
      color: #3b82fc;
    }
  }
}
</style>
